import { render, staticRenderFns } from "./completed-by.vue?vue&type=template&id=a18471c2&"
import script from "./completed-by.vue?vue&type=script&lang=js&"
export * from "./completed-by.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports